/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface BrandFormValidationData
 */
export interface BrandFormValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof BrandFormValidationData
     */
    id?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof BrandFormValidationData
     */
    label?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof BrandFormValidationData
     */
    effectiveDates?: ValidationMessage;
}

export function BrandFormValidationDataFromJSON(json: any): BrandFormValidationData {
    return BrandFormValidationDataFromJSONTyped(json, false);
}

export function BrandFormValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrandFormValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : ValidationMessageFromJSON(json['id']),
        'label': !exists(json, 'label') ? undefined : ValidationMessageFromJSON(json['label']),
        'effectiveDates': !exists(json, 'effectiveDates') ? undefined : ValidationMessageFromJSON(json['effectiveDates']),
    };
}

export function BrandFormValidationDataToJSON(value?: BrandFormValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': ValidationMessageToJSON(value.id),
        'label': ValidationMessageToJSON(value.label),
        'effectiveDates': ValidationMessageToJSON(value.effectiveDates),
    };
}


